import React, {useState, lazy, Suspense, useEffect} from 'react';

import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom"
import ConfigPage from "./ConfigPage";
import {MainRoutes} from "../admin/ebs/MainRoutes";
import {JiangoilRoutes} from "../web/jiangoil/MainRoutes";
import PageLoading from "../components/loading/PageLoading";
import {storage} from "../../utils/Storage";
import {createBrowserHistory} from "history";
import {WebRoutes} from "../web/ebs/WebRoutes";

function Router({basename,routes}) {

    const withParams = (Component, params) => {
        return props => <Component {...props} {...params} />;
    };

    const createRoutes=(routes)=>{
        return routes?.map(r=>{
            let Component=r.lazyComponent?lazy(r.lazyComponent):r.component;
            if(r.props){
                Component = withParams(Component, r.props);
            }
            if(r.lazyComponent){
                Component=<Suspense fallback={<PageLoading/>}><Component/></Suspense>
            }
            if(!r.root){
                Component=<ConfigPage>{Component}</ConfigPage>
            }
            return <Route key={r.path} path={r.path} element={Component}>
                {r.children?createRoutes(r.children):null}
            </Route>
        })
    }

    if(!routes)
        return null;

    return (
        <BrowserRouter basename={basename}>
            <Routes>
                {createRoutes(routes)}
            </Routes>
        </BrowserRouter>
    );
}

function ConfigRouter({sys}) {

    const history = createBrowserHistory()

    const adminRoutes={
        'admin':MainRoutes,
    }

    const webRoutes={
        'admin':WebRoutes,
        'jiangoil':JiangoilRoutes,
    }

    useEffect(() => {
        let path=window.location.pathname;
        if(path==='/'||path===''){
            if(sys.sysNo!=='admin'&&webRoutes[sys.sysNo]){
                history.push('/web')
                history.go();
            }else{
                history.push('/admin')
                history.go();
            }
        }
    }, [sys]);

    return (
        <>
            <Router basename={'/admin'} routes={adminRoutes[sys.sysNo]}/>
            <Router basename={'/web'} routes={webRoutes[sys.sysNo]}/>
            <Router basename={'/article'} routes={[
                {
                    path:'/:id',
                    lazyComponent:()=>import('../web/ebs/portal/ArticlePage')
                },
                {
                    path:'/code/:code',
                    lazyComponent:()=>import('../web/ebs/portal/ArticlePage')
                }
            ]}/>
            <Router basename={'/trace/code'} routes={[
                {
                    path:'/:id',
                    lazyComponent:()=>import('../web/ebs/trace/code/TraceCodePage')
                }
            ]}/>
        </>
    );
}

export default ConfigRouter;

